export const PopupClassName = 'dl-core-workbook-navigation-minimal';
